import { render, staticRenderFns } from "./ProductModalPriceComponent.html?vue&type=template&id=ee537b48&scoped=true&"
import script from "./ProductModalPriceComponent.js?vue&type=script&lang=js&"
export * from "./ProductModalPriceComponent.js?vue&type=script&lang=js&"
import style0 from "./ProductModalPriceComponent.scss?vue&type=style&index=0&id=ee537b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee537b48",
  null
  
)

export default component.exports